export var ENV = process.env.ENV;

export var isLocal = ENV == 'local'
export var isDevelopment = ENV == 'dev' || ENV == 'development' || 'local';
export var isUAT = ENV == 'uat' || ENV == 'test';
export var isTraining = ENV == 'trn' || ENV == 'training';
export var isProduction = ENV == 'prd' || ENV == 'production';

// Development URLs are default
export var FIREWEATHER_SITE_URL = "https://fireweather.dev.rfs.nsw.gov.au";
export var FIREWEATHER_API_URL = 'https://fireweather.dev.rfs.nsw.gov.au/gfeforecast/api';
export var FIREWEATHER_SERVICES_URL = "https://fireweather.dev.rfs.nsw.gov.au";
export var GUARDIAN_SERVICES_URL = "https://gis-guardian.apps.rfs.nsw.gov.au";

export var GEOSERVER_URL = "https://fireweather-geoserver.aig.dev.apps.rfs.nsw.gov.au/geoserver/fireweather/wms";
export var AIG_GEOSERVER_URL = "https://aig-geoserver.aig.dev.apps.rfs.nsw.gov.au/geoserver/wms";

export var INCIDENTS_URL = "https://utility.arcgis.com/sharing/rss?url=http%3A%2F%2Fwww.rfs.nsw.gov.au%2Ffeeds%2FmajorIncidents.xml&outSR=%7B%22wkid%22%3A4326%7D"; // No CORS Error, but doesn't have GUID
//export var INCIDENTS_URL = "https://utility.arcgis.com/sharing/rss?url=http://www.rfs.nsw.gov.au/feeds/majorIncidents.xml";

export var GIS_MAP_ARCGIS_SERVER = "https://gis-maps.apps.rfs.nsw.gov.au/arcgis/rest/services";

if (isLocal) {
    // Special case; If a local build, services won't exist
    FIREWEATHER_SITE_URL = "https://fireweather.rfs.nsw.gov.au";
    FIREWEATHER_API_URL = 'https://fireweather.rfs.nsw.gov.au/gfeforecast/api';
    FIREWEATHER_SERVICES_URL = "https://fireweather.rfs.nsw.gov.au";
    GUARDIAN_SERVICES_URL = "https://gis-guardian.apps.rfs.nsw.gov.au";
} if (isUAT) {
    // UAT URLs
    FIREWEATHER_SITE_URL = "https://fireweather.uat.rfs.nsw.gov.au";
    FIREWEATHER_API_URL = "https://fireweather.uat.rfs.nsw.gov.au/gfeforecast/api"
    FIREWEATHER_SERVICES_URL = "https://fireweather.uat.rfs.nsw.gov.au";
    GUARDIAN_SERVICES_URL = "https://gis-guardian.uat.apps.rfs.nsw.gov.au";
	GEOSERVER_URL = "https://shared-fireweather.uat.apps.rfs.nsw.gov.au/geoserver/fireweather/wms";
	AIG_GEOSERVER_URL = "https://aig-geoserver.aig.uat.apps.rfs.nsw.gov.au/geoserver/wms";	
} else if (isTraining) {
    // Training URLs
    FIREWEATHER_SITE_URL = "https://fireweather.trn.rfs.nsw.gov.au";
    FIREWEATHER_API_URL = "https://fireweather.trn.rfs.nsw.gov.au/gfeforecast/api"
    FIREWEATHER_SERVICES_URL = "https://fireweather.trn.rfs.nsw.gov.au";
    GUARDIAN_SERVICES_URL = "https://gis-guardian.trn.apps.rfs.nsw.gov.au";
	GEOSERVER_URL = "https://shared-fireweather.trn.apps.rfs.nsw.gov.au/geoserver/fireweather/wms";
	AIG_GEOSERVER_URL = "https://aig-geoserver.aig.trn.apps.rfs.nsw.gov.au/geoserver/wms";
} else if (isProduction) {
    // Production URLs
    FIREWEATHER_SITE_URL = "https://fireweather.rfs.nsw.gov.au";
    FIREWEATHER_API_URL = "https://fireweather.rfs.nsw.gov.au/gfeforecast/api"
    FIREWEATHER_SERVICES_URL = "https://fireweather.rfs.nsw.gov.au";
    GUARDIAN_SERVICES_URL = "https://gis-guardian.apps.rfs.nsw.gov.au";
	GEOSERVER_URL = "https://shared-fireweather.apps.rfs.nsw.gov.au/geoserver/fireweather/wms";
	AIG_GEOSERVER_URL = "https://aig-geoserver.aig.apps.rfs.nsw.gov.au/geoserver/wms";
}